import React, { useState } from "react";
import "./Checkbox.css";

const Checkbox = (props) => {
  const {
    label,
    isScrBound,
    setIsScrBound,
    isTitleSafe,
    setIsTitleSafe,
    isEmailSend,
    setIsEmailSend,
    isEmailSendtoAll,
    setIsEmailSendtoAll,
    isTermsandcon,
    setIsTermsandcon,
  } = props;

  const [isChecked, setIsChecked] = useState(
    isScrBound || isTitleSafe || isEmailSend || isEmailSendtoAll
  );

  const handleCheck = () => {
    if (setIsTitleSafe) {
      setIsTitleSafe(!isTitleSafe);
    }
    if (setIsScrBound) {
      setIsScrBound(!isScrBound);
    }
    if (setIsEmailSend) {
      setIsEmailSend(!isEmailSend);
    }
    if (setIsEmailSendtoAll) {
      setIsEmailSendtoAll(!isEmailSendtoAll);
    }
    if (setIsTermsandcon) {
      setIsTermsandcon(!isTermsandcon);
    }
  };

  return (
    <div className="Check">
      <label>
        <input type="checkbox" onChange={handleCheck} />
        <svg
          className={`checkbox ${
            isTitleSafe || isScrBound || isEmailSend || isEmailSendtoAll || isTermsandcon 
              ? "checkbox--active"
              : ""
          }`}
          // This element is purely decorative so
          // we hide it for screen readers
          aria-hidden="true"
          viewBox="0 0 15 11"
          fill="none"
        >
          <path
            d="M1 4.5L5 9L14 1"
            strokeWidth="3"
            stroke={props.isTitleSafe  ? "#141416" : "none" || props.isScrBound ? "#141416" : "none" }

          />
        </svg>
        {label && <span className="Lebel">{label}</span>}
      </label>
    </div>
  );
};

export default Checkbox;
